<template>
  <div
      v-if="banner.length>0 &&visible"
      class="floating-image"
      :style="{
      top: position.top + 'px',
      left: position.left + 'px',
      // width: size + 'px',
      // height: size + 'px'
    }"
  >
    <div class="close-btn" @click.stop="close">
      <img src="../assets/img/close.png" alt="关闭" />
    </div>
    <img
        :src="banner[0].pic"
        class="image"
        @mousedown="startDrag"
        @mouseup="handleClick(banner[0].value,banner[0].id)"
        @touchstart.prevent="startTouch"
        @touchend="handleTouchEnd"
        @touchmove="onTouchMove"
        @click="handleClick(banner[0].value,banner[0].id)"
    />

  </div>
</template>

<script>
export default {
  name: 'FloatingImage',
  data() {
    return {
      visible: true,
      position: { top: 0, left: 0 },
      dragging: false,
      moved: false,
      offset: { x: 0, y: 0 },
      longPressTimer: null,
      isTouching: false,
      banner:[],
      target:"",
    };
  },
  mounted() {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    
    // 计算基于750px设计稿的相对距离和尺寸
    const baseWidth = 750;
    const baseRightDistance = 66;
    const baseSize = 146; // 基准尺寸
    
    // 根据当前屏幕宽度计算实际右侧距离和尺寸
    const scale = vw / baseWidth;
    const rightDistance = baseRightDistance * scale;
    const actualSize = baseSize * scale;
    
    // 更新组件尺寸
    this.size = actualSize;
    
    // 更新位置
    this.position.top = vh - 500 * scale - actualSize;
    this.position.left = vw - rightDistance - actualSize;
  },
  created() {
    this.getBanner();
  },
  methods: {
    close() {
      console.log('关闭悬浮球');
      this.visible = false;
    },

    // PC端拖动
    startDrag(e) {
      this.dragging = true;
      this.moved = false;
      this.offset.x = e.clientX - this.position.left;
      this.offset.y = e.clientY - this.position.top;
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    onDrag(e) {
      if (this.dragging) {
        this.moved = true;
        this.position.left = e.clientX - this.offset.x;
        this.position.top = e.clientY - this.offset.y;
      }
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    handleClick(value,id) {
      if (!this.moved && this.target) {
        this.$report.sendReport({
          "id": id,
          "dt":1
        });
        // 跳转到目标链接
        if(this.target!==""){
          window.location.href = this.target;
        }
      }
    },

    // 移动端长按拖动
    startTouch(e) {
      this.moved = false;
      const touch = e.touches[0];
      this.isTouching = false;
      this.longPressTimer = setTimeout(() => {
        this.isTouching = true;
        this.offset.x = touch.clientX - this.position.left;
        this.offset.y = touch.clientY - this.position.top;
      }, 300);
    },
    onTouchMove(e) {
      if (!this.isTouching) return;
      const touch = e.touches[0];
      this.moved = true;
      this.position.left = touch.clientX - this.offset.x;
      this.position.top = touch.clientY - this.offset.y;
    },
    handleTouchEnd() {
      clearTimeout(this.longPressTimer);
      if (!this.moved && this.target) {
        window.open(this.target, '_blank');
      }
      this.isTouching = false;
    },
    async getBanner(){
      //获取banner
      const res = await this.axios.get(`https://api.ayerdudu.com/v1/banner/banners`)
      console.log(res)
      res.data.data.forEach((item) => {
        if(item.enable&&item.position_code===2){
          this.banner.push(item);
        }
      })
      if (this.banner.length>0){
        this.target = this.banner[0].value;
      }

      console.log('banner数据---',this.banner)
    },
  }
};
</script>

<style scoped>
.floating-image {
  position: fixed;
  z-index: 9999;
  user-select: none;
  touch-action: none;
  width: 146px;
  height: 146px;
  right: 66px;
}

.image {
  display: block;
  width: 146px;
  height: 146px;
  cursor: move;
  pointer-events: auto;
}

.close-btn {
  position: absolute;
  bottom: 100%;
  margin-bottom: 11px;
  right: -17px;
  color: white;
  border-radius: 50%;
  width: 39px;
  height: 39px;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.close-btn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
